import React from "react";
import ReactDom from "react-dom";
import {Accordion, AccordionTab} from 'primereact/accordion';
import InnerLoading from "../RelatorioRevendaLocacao/InnerLoading";
import AsyncSelect from "react-select/async";
import {MultiSelect} from 'primereact/multiselect';
import {InputSwitch} from 'primereact/inputswitch';
import {Dialog} from 'primereact/dialog';
import {Dropdown} from "primereact/dropdown";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt_BR from 'date-fns/locale/pt-BR';
import Pagination from "react-js-pagination";
import ModalColetas from "./ModalColetas";
import ModalEditarWorkflow from "./ModalEditarWorkflow";
import {OverlayPanel} from 'primereact/overlaypanel';
import ModalEditarWorkflowEmMassa from "./ModalEditarWorkflowEmMassa";
import {Toast} from 'primereact/toast';

registerLocale('pt-BR', pt_BR);

class ColetaAutomatizada extends React.Component {

    MAX_SELECTION_FOR_BATCH_UPDATE = 100;

    initialFilters = {
        usa_workflow: null,
        cidade: null,
        tipos: [],
        workflow_criado: null,
        ultima_execucao_maior_que: null,
        ultima_execucao_menor_que: null,
        frequencia: null,
        com_resultados: null
    }

    constructor(props) {
        super(props);
        this.op = React.createRef();
        this.state = {
            loading: false,
            sites: [],
            activeIndex: 0,
            cidade: '',
            tipos: [],
            usa_workflow: false,
            workflow_criado: false,
            current_edit: null,
            show_modal_dados: false,
            show_modal_delete: false,
            coletas_showing: [],
            ignorados: [],
            filters: this.initialFilters,
            success_message: '',
            show_message: '',
            pagination: {
                current_page: 1, per_page: 10, total: 0, from: 0, to: 0
            },
            current_site_cities: [],
            ids_selecionados: [],
            show_modal_acoes_em_grupo: false,
            batch_workflow_frequency: null,
            show_modal_erros_criacao: false,
            erros_criacao_workflows: [],
        };
    }


    tipos = [{label: 'Horizontal', value: 'Horizontal'}, {label: 'Vertical', value: 'Vertical'}, {
        label: 'Comercial', value: 'Comercial'
    }, {label: 'Hotel', value: 'Hotel'},];

    frequencias = [{label: "Diário", value: "DAILY"}, {label: "Semanal", value: "WEEKLY"}, {
        label: "Mensal", value: "MONTHLY"
    }, {label: "Único", value: "ONLY_ONCE"},];

    /**
     * ACTIVE, ERROR, PAUSED, NOT_SUPPORTED, PREVIEW, QUEUED, SETUP, DELETED
     * @type {[{label: string, value: string},{}]}
     */
    workflow_status_options = [
        {
            label: 'Ativo', value: 'ACTIVE'
        },
        {
            label: 'ERROR', value: 'ERROR'
        },
        {
            label: 'PAUSED', value: 'PAUSED'
        },
        {
            label: 'NOT_SUPPORTED', value: 'NOT_SUPPORTED'
        },
        {
            label: 'PREVIEW', value: 'PREVIEW'
        },
        {
            label: 'QUEUED', value: 'QUEUED'
        },
        {
            label: 'SETUP', value: 'SETUP'
        },
        {
            label: 'DELETED', value: 'DELETED'
        },
        {
            label: 'DELETED_ERROR', value: 'DELETED_ERROR'
        }
    ];


    estados = [{label: 'Acre', value: 'AC'}, {label: 'Alagoas', value: 'AL'}, {label: 'Amapá', value: 'AP'},]


    componentDidMount = async () => {
        await this.getSites();
    }

    setLoading = (loading) => {
        this.setState({loading: loading});
    }

    searchCidade = async (inputQuery) => {
        if (inputQuery.length >= 2) {
            const response = await axios.get('/cidades/json-options-with-state-on-values/' + inputQuery);
            return response.data;
        }
    }

    clearFilters = async (e) => {
        debugger;
        e.preventDefault();

        await this.setState({
            ...this.state, filters: {
                ...this.initialFilters,
            }
        });

        await this.getSites();
    }

    getSites = async () => {
        try {

            await this.setState({
                ...this.state, sites: []
            });

            await this.setLoading(true);


            let payload = this.getRequestPayload();

            let requestExtraParams = {};

            if( this.state.filters.export_excel ){
                requestExtraParams.responseType = 'blob';
            }

            const response = await axios.get(route('coleta-automatizada.index', payload), requestExtraParams);

            if( response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ){
                this.handleDownloadExcel(response);
                return;
            }



            if (response.status === 200) {
                this.setState({
                    ...this.state, sites: response.data.data, pagination: {
                        current_page: response.data.current_page,
                        per_page: response.data.per_page,
                        total: response.data.total,
                        from: response.data.from,
                        to: response.data.to
                    }
                });
            }
        } catch (e) {
            console.log(e);
        } finally {
            await this.setLoading(false);
        }
    }

    handleDownloadExcel(response) {
        const type = response.headers['content-type']
        const blob = new Blob([response.data], {type: type, encoding: 'UTF-8'})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = response.headers['content-disposition'].split(';')[1].split('=')[1];
        link.click()

        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                export_excel: false
            }
        });

    }

    getRequestPayload = () => {
        return {
            page: this.state.pagination.current_page || 1,
            cidade: this.state.filters.cidade ? this.state.filters.cidade.value : null,
            tipos: this.state.filters.tipos,
            usa_workflow: this.state.filters.usa_workflow,
            workflow_criado: this.state.filters.workflow_criado,
            ultima_execucao_maior_que: this.state.filters.ultima_execucao_maior_que,
            ultima_execucao_menor_que: this.state.filters.ultima_execucao_menor_que,
            frequencia: this.state.filters.frequencia,
            com_resultados: this.state.filters.com_resultados,
            export_excel: this.state.filters.export_excel,
            link: this.state.filters.link,
            workflow_status: this.state.filters.workflow_status
        };
    }


    onHide = async () => {
        this.setState({
            ...this.state, show_modal_edit: false
        });
    }

    onHideDelete = async () => {
        this.setState({
            ...this.state, show_modal_delete: false
        });
    }

    handleChange = (field, value) => {
        this.setState({
            ...this.state, current_edit: {
                ...this.state.current_edit, [field]: value
            }
        });
    };

    handleChangeBatchFrequency = (field, value) => {
        this.setState({
            ...this.state, batch_workflow_frequency: value
        });
    }


    showDataModal = async (site) => {

        await this.getWorkflowRun(site.ultima_execucao_workflow_id);

        await this.setState({
            ...this.state, current_edit: site, show_modal_dados: true
        });
    }

    getWorkflowRun = async (id) => {
        try {
            await this.setLoading(true);

            const response = await axios.get(route('web.workflow_run.show', id));

            await this.setState({
                ...this.state,
                coletas_showing: response.data.runs,
                ignorados: response.data.ignorados.map((i) => i.hash)
            });
        } catch (error) {
            console.log(error);
        } finally {
            await this.setLoading(false);
        }
    }

    closeDataModal = async () => {
        await this.setState({show_modal_dados: false});
    }

    handlePageChange = async (pageNumber) => {
        await this.setState({
            ...this.state, pagination: {
                ...this.state.pagination, current_page: pageNumber
            }
        });

        await this.getSites();
    }

    removeWorkflow = async () => {
        try {
            await this.setLoading(true);

            debugger;

            let response = await axios.delete(route('coleta-automatizada.destroy', this.state.current_edit.id));

            if (response.status === 200) {
                await this.getSites();
            }

            await this.setState({
                ...this.state, current_edit: null, success_message: 'Workflow removido com sucesso.', show_message: true
            });

        } catch (e) {
            debugger;
            if (e.response && e.response.status === 422) {
                this.setState({
                    ...this.state, errors: e.response.data.errors
                });
            }

            //erro response code 500
            if (e.response && e.response.status === 500) {
                this.setState({
                    ...this.state, errors: {
                        message: 'Ocorreu um erro inesperado. Tente novamente mais tarde.'
                    }
                });
            }
        } finally {
            await this.setState({
                ...this.state, show_modal_delete: false, loading: false
            });

            this.scrollToTop();
        }
    }


    createWorkflow = async (site) => {
        try {
            await this.setLoading(true);

            let response = await axios.post(route('coleta-automatizada.store'), {
                mapeamento_id: site.id
            });

            if (response.status === 200) {
                await this.getSites();
            }

            await this.setState({
                ...this.state, current_edit: null, success_message: 'Workflow criado com sucesso.', show_message: true
            });

        } catch (e) {
            debugger;
            if (e.response && e.response.status === 422) {

                /*this.setState({
                    ...this.state, errors: e.response.data.errors
                });*/

                this.toast.show(
                    {
                        severity: 'error',
                        summary: 'Erro',
                        detail: Object.values(e.response.data.errors).join(' '),
                        life: 9000
                    }
                )


            }

            //erro response code 500
            if (e.response && e.response.status === 500) {
                /*this.setState({
                    ...this.state, errors: {
                        message: 'Ocorreu um erro inesperado. Tente novamente mais tarde.'
                    }
                });*/
                this.toast.show(
                    {
                        severity: 'error',
                        summary: 'Erro',
                        detail: Object.values(e.response.data.errors).join(' '),
                        life: 9000
                    }
                )
            }
        } finally {
            await this.setState({
                ...this.state, loading: false
            });

            this.scrollToTop();
        }
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0, behavior: "smooth"
        });
    }

    ignoreColeta = async ({id, title, url}) => {
        try {

            await this.setLoading(true);

            const response = await axios.post(route('web.workflow_data.ignore'), {
                mapeamento_id: id, titulo: title, url: url
            });

            await this.setState({
                ...this.state, ignorados: [...this.state.ignorados, response.data.hash]
            });
        } catch (error) {
            console.log(error);

        } finally {
            this.setLoading(false);
        }
    }

    cadastrarEmpreendimento = async (coleta) => {
        try {
            const response = await axios.post(route('web.workflow_cadastrar_empreendimento'), coleta);

            if (response.status === 200) {
                //abrir nova aba com o endereço
                window.open(response.data.redirect_url, '_blank');
            }
        } catch (e) {
            console.log(e);
        } finally {
            this.setLoading(false);
        }
    }

    executeWorkflow = async (site) => {
        try {
            await this.setLoading(true);

            let response = await axios.post(route('coleta-automatizada.execute'), {
                workflow_id: site.workflow_id
            });


            await this.setState({
                ...this.state,
                current_edit: null,
                success_message: 'Workflow enfileirado para execução.',
                show_message: true
            });

        } catch (e) {
            if (e.response && e.response.status === 422) {
                this.setState({
                    ...this.state, errors: e.response.data.errors
                });
            }

            //erro response code 500
            if (e.response && e.response.status === 500) {
                this.setState({
                    ...this.state, errors: {
                        message: 'Ocorreu um erro inesperado. Tente novamente mais tarde.'
                    }
                });
            }
        } finally {
            await this.setState({
                ...this.state, loading: false
            });

            this.scrollToTop();
        }
    }

    handleSave = async () => {
        try {
            this.setLoading(true);

            const response = await axios.put(route('coleta-automatizada.update', this.state.current_edit.id), {
                use_workflow: this.state.current_edit.use_workflow,
                workflow_frequency: this.state.current_edit.workflow_frequency
            });

            if (response.status === 200) {
                this.toast.show(
                    {
                        severity: 'success',
                        summary: 'Sucesso',
                        detail: 'Workflow atualizado com sucesso.',
                        life: 9000
                    }
                )

                await this.getSites();
            }

        } catch (e) {
            console.log(e);
        } finally {
            await this.setState({
                ...this.state, show_modal_edit: false, loading: false
            });
        }
    }

    checkAll = async (e) => {
        if (e.target.checked) {

            let ids = this.state.sites.map((site) => site.id);
            await this.setState({
                ids_selecionados: ids
            });

            return;

        }

        await this.setState({
            ids_selecionados: []
        });
    }


    handleCheck = async (e) => {
        let id = parseInt(e.target.value);

        if (e.target.checked) {
            await this.setState({
                ids_selecionados: [...this.state.ids_selecionados, id]
            });
            return;
        }

        const newIds = this.state.ids_selecionados.filter((item) => item !== id);
        await this.setState({
            ids_selecionados: [...newIds]
        });

    }

    showModalAcoesEmGrupo = async () => {
        if( this.state.ids_selecionados.length > this.MAX_SELECTION_FOR_BATCH_UPDATE ){
            alert(`Você pode selecionar no máximo ${this.MAX_SELECTION_FOR_BATCH_UPDATE} sites para atualizar a frequência em massa.`);
            return;
        }

        await this.setState({
            ...this.state, show_modal_acoes_em_grupo: true
        });
    }

    closeModalAcoesEmGrupo = async () => {
        await this.setState({
            ...this.state, show_modal_acoes_em_grupo: false
        });
    }

    handleBatchUpdate = async () => {
        try{
            await this.setLoading(true);

            const response = await axios.post( route('coleta-automatizada.batch-update'), {
                ids: this.state.ids_selecionados,
                workflow_frequency: this.state.batch_workflow_frequency
            });

            if( response.status === 200 ){
                await this.setState({
                    ...this.state, success_message: 'As atualizações foram enfileiradas para alteração.', show_message: true
                });
            }

            await this.closeModalAcoesEmGrupo();

        }catch (e){
            console.log(e);
        }finally {
            await this.setLoading(false);
        }
    }

    showModalErrosCriacao = async ( erros ) => {
        await this.setState({
            ...this.state,
            show_modal_erros_criacao: true,
            errors_criacao_workflows: erros
        });
    }


    render() {
        return (<React.Fragment>

            <Toast ref={(el) => this.toast = el} position="top-right"/>

            <ModalColetas
                show={this.state.show_modal_dados}
                handleClose={this.closeDataModal}
                coletas={this.state.coletas_showing}
                site={this.state.current_edit}
                ignoreColeta={this.ignoreColeta}
                ignorados={this.state.ignorados}
                loading={this.state.loading}
                cadastrarEmpreendimento={this.cadastrarEmpreendimento}
            />

            <ModalEditarWorkflow
                show={this.state.show_modal_edit}
                onHide={this.onHide}
                current_edit={this.state.current_edit}
                frequencias={this.frequencias}
                handleChange={this.handleChange}
                handleSave={this.handleSave}
            />

            <ModalEditarWorkflowEmMassa
                show={this.state.show_modal_acoes_em_grupo}
                onHide={this.closeModalAcoesEmGrupo}
                frequencias={this.frequencias}
                handleChange={this.handleChangeBatchFrequency}
                handleSave={this.handleBatchUpdate}
                batch_workflow_frequency={this.state.batch_workflow_frequency}
            />

            <Dialog header="Remover Workflow"
                    position="top"
                    visible={this.state.show_modal_delete}
                    style={{width: '50vw'}}
                    modal onHide={this.onHideDelete}>
                <div className="container-fluid">
                    <div className="form-group row">
                        <div className="col-12">
                            <p>Tem certeza que deseja remover o workflow do
                                site {this.state?.current_edit?.portal}?</p>
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-12">
                            <button className="btn btn-sm btn-block btn-danger" onClick={this.removeWorkflow}>
                                Remover
                            </button>
                        </div>
                    </div>
                </div>

            </Dialog>


            <Dialog header="Tentivas de Criação de Workflow"
                    visible={this.state.show_modal_erros_criacao}
                    style={{ width: '50vw' }}
                    onHide={() => this.setState({ show_modal_erros_criacao: false })}>

                <div>
                    <table className="table table-bordered table-striped">
                        <thead>
                            <tr>
                                <td>Data</td>
                                <td>Erro</td>
                            </tr>
                        </thead>
                        <tbody>
                        {this.state.errors_criacao_workflows?.map((error)=>{
                            return (
                                <tr>
                                    <td>{error.created_at_formatted}</td>
                                    <td>{error.error_message}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>

            </Dialog>


            <div className="row">
                {this.state.show_message && <>
                    <div className="col-12">
                        <div className="alert alert-success alert-dismissible">
                            {this.state.success_message}

                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                </>}

                {this.state.errors && <>
                    <div className="col-12">
                        <div className="alert alert-danger alert-dismissible">
                            {Object.keys(this.state.errors).map((key, index) => {
                                return (<p key={index}>{this.state.errors[key]}</p>);
                            })}
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                </>}
            </div>

            <Accordion activeIndex={this.state.activeIndex}
                       onTabChange={(e) => this.setState({activeIndex: e.index})}>
                <AccordionTab header="Busca">
                    <div>
                        <div className="form-group row">
                            <div className="col-12 col-md-6 col-sm-6">
                                <label htmlFor="">Cidade</label>
                                <AsyncSelect
                                    cacheOptions
                                    isClearable
                                    noOptionsMessage={() => 'Nenhum Resultado'}
                                    placeholder="Digite para buscar..."
                                    value={this.state.filters.cidade}
                                    loadOptions={this.searchCidade}
                                    onChange={async (e) => {
                                        await this.setState({
                                            ...this.state, filters: {
                                                ...this.state.filters, cidade: e
                                            }
                                        });
                                    }}
                                />
                            </div>

                            <div className="col-12 col-md-4 col-sm-4">
                                <label htmlFor="">Site</label> <br/>
                                <input type="text" className="form-control"
                                       value={this.state.filters.link || ''}
                                       onChange={(e) => this.setState({
                                           ...this.state, filters: {
                                               ...this.state.filters, link: e.target.value
                                           }
                                       })}/>

                            </div>

                            <div className="col-12 col-md-2 col-sm-2">
                                <label htmlFor="">Tipos</label> <br/>
                                <MultiSelect display="chip"
                                             style={{width: '100%'}}
                                             optionLabel="label"
                                             value={this.state.filters.tipos}
                                             options={this.tipos}
                                             onChange={(e) => this.setState({
                                                 ...this.state, filters: {
                                                     ...this.state.filters, tipos: e.value
                                                 }
                                             })}/>

                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-12 col-md-3 col-sm-3">
                                <label htmlFor="">Última Execução Maior Que</label>
                                <DatePicker
                                    locale="pt-BR"
                                    className="form-control"
                                    dateFormat="dd/MM/yyyy"
                                    selected={this.state.filters.ultima_execucao_maior_que}
                                    onChange={async (e) => {
                                        await this.setState({
                                            ...this.state, filters: {
                                                ...this.state.filters, ultima_execucao_maior_que: e
                                            }
                                        });
                                    }}
                                />
                            </div>

                            <div className="col-12 col-md-3 col-sm-3">
                                <label htmlFor="">Última Execução Menor Que</label>
                                <DatePicker
                                    locale="pt-BR"
                                    className="form-control"
                                    dateFormat="dd/MM/yyyy"
                                    selected={this.state.filters.ultima_execucao_menor_que}
                                    onChange={async (e) => {
                                        await this.setState({
                                            ...this.state, filters: {
                                                ...this.state.filters, ultima_execucao_menor_que: e
                                            }
                                        });
                                    }}
                                />
                            </div>

                            <div className="col-12 col-md-3 col-sm-3">
                                <label htmlFor="">Frequência do Workflow</label>
                                <Dropdown
                                    style={{width: '100%'}}
                                    value={this.state.filters.frequencia}
                                    options={this.frequencias}
                                    onChange={(e) => this.setState({
                                        ...this.state, filters: {
                                            ...this.state.filters, frequencia: e.value
                                        }
                                    })}
                                    placeholder="Selecione a frequência"
                                />
                            </div>
                            <div className="col-12 col-md-3 col-sm-3">
                                <label htmlFor="">Status do Workflow</label>
                                <Dropdown
                                    style={{width: '100%'}}
                                    value={this.state.filters.workflow_status}
                                    options={this.workflow_status_options}
                                    onChange={(e) => this.setState({
                                        ...this.state, filters: {
                                            ...this.state.filters, workflow_status: e.value
                                        }
                                    })}
                                    placeholder="Selecione"
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-12 col-md-6 col-sm-6">
                                <label htmlFor="">Workflow Criado</label> <br/>
                                <InputSwitch
                                    checked={this.state.filters.workflow_criado}
                                    onChange={(e) => this.setState({
                                        ...this.state, filters: {
                                            ...this.state.filters, workflow_criado: e.value
                                        }
                                    })}/>
                                <br/>
                                <label htmlFor="">Workflow Habilitado</label> <br/>
                                <InputSwitch
                                    checked={this.state.filters.usa_workflow}
                                    onChange={(e) => this.setState({
                                        ...this.state, filters: {
                                            ...this.state.filters, usa_workflow: e.value
                                        }
                                    })}/>

                            </div>

                            <div className="col-12 col-md-6 col-sm-6">
                                <label htmlFor="">Somente com Resultados</label> <br/>
                                <InputSwitch
                                    checked={this.state.filters.com_resultados}
                                    onChange={(e) => this.setState({
                                        ...this.state, filters: {
                                            ...this.state.filters, com_resultados: e.value
                                        }
                                    })}/>

                            </div>
                        </div>

                        <div className="form-group row">
                            <div className="col-12 col-md-4 col-sm-4">
                                <button className="btn btn-block btn-sm btn-success" onClick={async () => {
                                    await this.setState({
                                        ...this.state, pagination: {
                                            ...this.state.pagination, current_page: 1
                                        }
                                    });

                                    await this.getSites();
                                }}>
                                    Pesquisar
                                </button>
                            </div>
                            <div className="col-12 col-md-4 col-sm-4">
                                <button className="btn btn-block btn-sm btn-secondary" onClick={async () => {
                                    await this.setState({
                                        ...this.state,
                                        filters: {
                                            ...this.state.filters,
                                            export_excel: true,
                                        },
                                        pagination: {
                                            ...this.state.pagination, current_page: 1
                                        }
                                    });

                                    await this.getSites();
                                }}>
                                    Exportar Excel &nbsp;
                                    <i className="fa fa-file-excel-o"></i>

                                </button>
                            </div>

                            <div className="col-12 col-md-4 col-sm-4">
                                <button className="btn btn-block btn-sm btn-danger" onClick={this.clearFilters}>
                                    Limpar Filtros
                                </button>
                            </div>
                        </div>

                    </div>
                </AccordionTab>
            </Accordion>
            <hr/>

            <OverlayPanel appendTo={document.body} ref={this.op}
                          id={`overlay_panel_cidades`} style={{width: '450px'}}>
                <ul className="list-group">
                    {this.state.current_site_cities.map((city) => {
                        return <li className="list-group-item"
                                   key={city.id}>{city.city} - {city.state}</li>
                    })}
                </ul>
            </OverlayPanel>

            <div className="d-flex justify-content-between align-items-center">

                {!this.state.loading && <p className="small text-muted">
                    Exibindo resultados de {this.state.pagination.from} até {this.state.pagination.to} de um total
                    de {Number(this.state.pagination.total).toLocaleString()} registros.
                </p>

                }

                <div>

                    <div className="dropdown">
                        <button className="btn btn-secondary dropdown-toggle" type="button"
                                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                disabled={this.state.ids_selecionados.length === 0}
                                aria-expanded="false">
                            Ações em Grupo
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">

                            <button className="dropdown-item" onClick={this.showModalAcoesEmGrupo}>
                                <i className="fa fa-edit"></i> &nbsp;
                                Atualizar Frequência
                            </button>


                        </div>
                    </div>

                </div>
            </div>

            <div style={{overflowX: 'auto'}}>
                {this.state.loading && <InnerLoading/>}
                <table className="table table-striped" style={{
                    borderTopRightRadius: '5px', borderTopLeftRadius: '5px'
                }}>
                    <thead>
                    <tr style={{
                        backgroundColor: 'green',
                        color: '#333',
                        fontWeight: 'bold',
                        borderTopRightRadius: '5px',
                        borderTopLeftRadius: '5px'
                    }}>
                        <th>
                            <input type="checkbox"
                                   className="checkbox"
                                   defaultChecked={this.state.sites.length > 0 && ( this.state.ids_selecionados.length === this.state.sites.length || this.state.ids_selecionados.length === this.state.pagination.total )}
                                   onClick={this.checkAll}/>

                        </th>
                        <th style={{fontWeight: 'bold', color: 'white'}}>Portal</th>
                        <th style={{fontWeight: 'bold', color: 'white'}}>Tipo</th>
                        <th style={{fontWeight: 'bold', color: 'white'}}>Cidade</th>
                        <th style={{fontWeight: 'bold', color: 'white'}}>Workflow Habilitado</th>
                        <th style={{fontWeight: 'bold', color: 'white'}}>Workflow Criado</th>
                        <th style={{fontWeight: 'bold', color: 'white'}}>Status do Workflow</th>
                        <th style={{fontWeight: 'bold', color: 'white'}}>Frequência do Workflow</th>
                        <th style={{fontWeight: 'bold', color: 'white'}}>Útima Execução do Workflow</th>
                        <th style={{fontWeight: 'bold', color: 'white'}}>Número de Execuções</th>
                        <th style={{fontWeight: 'bold', color: 'white'}}>Resultados da ùltima Coleta</th>
                        <th style={{fontWeight: 'bold', color: 'white'}}>Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.sites.map((site, index) => {
                        const slicedCities = site.cities.slice(0, 3);
                        return (


                            <tr key={index}>
                                <td>
                                    <input type="checkbox" name="ids_selecionados"
                                           className="checkbox"
                                           checked={this.state.ids_selecionados.includes(parseInt(site.id))}
                                           onChange={this.handleCheck}
                                           value={parseInt(site.id)}/>
                                </td>
                                <td>
                                    {site.portal} - &nbsp;
                                    <a href={site.link} target="_blank">
                                        {site.link} &nbsp;
                                        <i className="fa fa-external-link"></i>
                                    </a>
                                </td>

                                <td>{site.type}</td>
                                <td>

                                    {site.cities.length && <React.Fragment>
                                        {slicedCities.map((city, index) => {
                                            return <React.Fragment key={`ci_${city.id}`}>
                                                <span style={{fontSize: '11px'}}>{city.city} - {city.state}</span>
                                                <br/></React.Fragment>
                                        })} &nbsp;
                                        {site.cities.length > 3 && <React.Fragment>
                                            <span className="font-weight-bold">Mais {site.cities.length - 3}</span> <br />
                                            <a className="btn-link" onClick={async (e) => {
                                                e.persist();
                                                e.preventDefault();
                                                await this.setState({
                                                    ...this.state, current_site_cities: site.cities
                                                })
                                                this.op.current.toggle(e);
                                            }}>

                                                <i className="fa fa-ellipsis"></i>
                                            </a>
                                            &nbsp;
                                        </React.Fragment>}
                                    </React.Fragment>}
                                </td>
                                <td>
                                    {site.use_workflow && <span className="badge badge-success">Sim</span>}
                                    {!site.use_workflow && <span className="badge badge-danger">Não</span>}
                                </td>
                                <td>
                                    {site.workflow_id && <span className="badge badge-success">Sim</span>}
                                    {!site.workflow_id && <span className="badge badge-danger">Não</span>}
                                </td>
                                <td>
                                    {site.workflow_status === 'ACTIVE' && <span className="badge badge-success">Ativo</span>}
                                    {['PAUSED', 'PREVIEW', 'QUEUED', 'DRAFT', 'SETUP_RUNNING', 'RUNNING'].includes(site.workflow_status) && <span className="badge badge-warning">{site.workflow_status}</span>}
                                    {['ERROR', 'ERROR_SETUP', 'NOT_SUPPORTED', 'DELETED_ERROR'].includes(site.workflow_status) && <span className="badge badge-danger">{site.workflow_status}</span>}
                                </td>

                                <td>
                                    {site.workflow_frequency === 'MONTHLY' && 'Mensal'}
                                    {site.workflow_frequency === 'WEEKLY' && 'Semanal'}
                                    {site.workflow_frequency === 'DAILY' && 'Diário'}
                                    {site.workflow_frequency === 'ONLY_ONCE' && 'Único'}
                                </td>
                                <td>
                                    {site.ultima_execucao_workflow_formatted}
                                </td>
                                <td>
                                    {site.runs_count}
                                </td>
                                <td>
                                    {site.quantidade_coletas}
                                </td>

                                <td>
                                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                        <button className="btn btn-sm btn-success" onClick={(e) => {
                                            e.preventDefault();
                                            this.setState({
                                                ...this.state, current_edit: site, show_modal_edit: true
                                            });
                                        }}>
                                            <i className="fa fa-edit"></i>
                                        </button>

                                        &nbsp;

                                        {site.quantidade_coletas > 0 && <>
                                            <button className="btn btn-sm btn-primary"
                                                    title="Dados Coletados"
                                                    onClick={async (e) => {
                                                        e.preventDefault();
                                                        await this.showDataModal(site);
                                                    }}
                                            >
                                                <i className="fa fa-list"></i>
                                            </button>
                                        </>}

                                        &nbsp;

                                        {site.workflow_id && <>
                                            <button className="btn btn-sm btn-success"
                                                    title="Executar Workflow"
                                                    onClick={async (e) => {
                                                        e.preventDefault();
                                                        await this.executeWorkflow(site);
                                                    }}
                                            >
                                                <i className="fa fa-play"></i>
                                            </button>
                                        </>}

                                        &nbsp;

                                        {!site.workflow_id && !site.workflow_retry_creation_scheduled_at && <>
                                            <button className="btn btn-sm btn-success"
                                                    title="Criar Workflow"
                                                    onClick={async (e) => {
                                                        e.preventDefault();
                                                        await this.createWorkflow(site);
                                                    }}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button>
                                        </>}

                                        {site.workflow_retry_creation_scheduled_at && <React.Fragment>
                                            <button className="btn btn-sm btn-warning"
                                                    title={`Houve falha na criação do workflow. Novas tentativas agendadas.`}
                                                    onClick={(e)=>{
                                                        e.preventDefault();

                                                        this.showModalErrosCriacao( site.workflow_creation_failures );


                                                    }}
                                            >
                                                <i className="fa fa-info"></i>
                                            </button>
                                        </React.Fragment>}

                                        &nbsp;

                                        {site.workflow_id && <>
                                            <button className="btn btn-sm btn-danger"
                                                    title="Excluir Workflow"
                                                    onClick={async (e) => {
                                                        e.preventDefault();
                                                        await this.setState({
                                                            ...this.state, current_edit: site, show_modal_delete: true
                                                        });
                                                    }}
                                            >
                                                <i className="fa fa-trash"></i>
                                            </button>
                                        </>}

                                    </div>
                                </td>
                            </tr>);

                    })}
                    </tbody>
                </table>
                <hr/>
                <div className="d-flex justify-content-center">
                    <Pagination
                        activePage={this.state.pagination.current_page}
                        itemsCountPerPage={this.state.pagination.per_page}
                        totalItemsCount={this.state.pagination.total}
                        pageRangeDisplayed={10}
                        onChange={this.handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                    />
                </div>
            </div>
        </React.Fragment>);
    }
}

if (document.getElementById('js-coleta-automatizada-gerenciamento')) {
    ReactDom.render(<ColetaAutomatizada/>, document.getElementById('js-coleta-automatizada-gerenciamento'));
}
